import { render, staticRenderFns } from "./CardManagementCard.vue?vue&type=template&id=3bfff7be&scoped=true&"
import script from "./CardManagementCard.vue?vue&type=script&lang=js&"
export * from "./CardManagementCard.vue?vue&type=script&lang=js&"
import style0 from "./CardManagementCard.vue?vue&type=style&index=0&id=3bfff7be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfff7be",
  null
  
)

export default component.exports